// npm
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getExamData } from "redux/reducers/selectors";
import { getShowExamInFullScreen } from "redux/reducers/exam/selectors";
import { getSettingsData } from "redux/reducers/selectors";
import { getClientSettingsData } from "redux/reducers/settings/selectors";
import {
    getOrgFullScreenExam,
    getOrgLeaveExamAttempts,
    getOrgLeaveExamType,
} from "redux/reducers/settings/client/selectors";

import { SET_SHOW_EXAM_IN_FULL_SCREEN, SET_FULL_SCREEN_MAX_ATTEMPTS } from "redux/reducers/exam/action-types";

// react
import { ExamIntroPageMachine } from "./machine";

class ExamIntro extends Component {
    constructor(props) {
        super(props);

        const {
            match: { params },
        } = props;

        const {
            needToSetShowExamInFullScreen,
            setShowExamInFullScreen,
            leaveExamAttempts,
            setFullScreenMaxAttempts,
        } = props;

        if (needToSetShowExamInFullScreen) {
            setShowExamInFullScreen(true);
            setFullScreenMaxAttempts(leaveExamAttempts);
        }

        this.examGuid = params.examGuid;
    }

    render() {
        return <ExamIntroPageMachine examGuid={this.examGuid} />;
    }
}

ExamIntro.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            examGuid: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const mapStoreToProps = (store) => {
    let needToSetShowExamInFullScreen = false;
    let leaveExamAttempts = -1;

    const examData = getExamData(store);
    const showExamInFullScreen = getShowExamInFullScreen(examData);

    if (!showExamInFullScreen) {
        const settingsData = getSettingsData(store);
        const clientSettingsData = getClientSettingsData(settingsData);

        const leaveExamType = getOrgLeaveExamType(clientSettingsData);
        needToSetShowExamInFullScreen = Boolean(leaveExamType === 1);

        leaveExamAttempts = getOrgLeaveExamAttempts(clientSettingsData);

        // needToSetShowExamInFullScreen =
        //     getOrgFullScreenExam(clientSettingsData);
    }

    return { needToSetShowExamInFullScreen, leaveExamAttempts };
};

const mapDispatchToProps = (dispatch) => ({
    setShowExamInFullScreen: (value) => {
        dispatch({
            type: SET_SHOW_EXAM_IN_FULL_SCREEN,
            value,
        });
    },
    setFullScreenMaxAttempts: (value) => {
        dispatch({
            type: SET_FULL_SCREEN_MAX_ATTEMPTS,
            value,
        });
    },
});

ExamIntro = connect(mapStoreToProps, mapDispatchToProps)(ExamIntro);

export { ExamIntro };
